// ABOUTME: One circle of the bubbles animation, growing and shrinking on a 1.2s loop
// ABOUTME: Positioned horizontally by x; begin offsets its start so the three run in sequence
import * as React from 'react';

interface Props {
  x: number;
  begin: string;
}

const Bubble: React.FC<Props> = ({ x, begin }) => (
  <circle transform={`translate(${x} 0)`} cx="0" cy="16" r="0">
    <animate
      attributeName="r"
      values="0; 4; 0; 0"
      dur="1.2s"
      repeatCount="indefinite"
      begin={begin}
      keyTimes="0;0.2;0.7;1"
      keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8"
      calcMode="spline"
    />
  </circle>
);

export default Bubble;
